<script>
    export let value;
    export let label = "";
    export let type; // one of 'icon' or 'image'
    export let isHorizontal = false;

    import ImageUploader from "../utils/ImageUploader.svelte";
    import {uploadIcon, uploadImage} from "../api.js";
    import {alert} from "../store";
    import to from "await-to-js";

    let imageUrl = value;
    $: inProgress = false;
    $: value = imageUrl;

    const uploadTheIcon = async data => {
        let func;

        if (type === "icon") func = uploadIcon;
        else if (type === "image") func = uploadImage;
        else throw new Error("prop type is required");

        inProgress = true;

        let [err, response] = await to(func(data));

        inProgress = false;
        
        if (err) return;

        imageUrl = (response.data || {}).url;
    };

    const deleteImage = () => (imageUrl = "");
</script>

<div class="field" class:is-horizontal={isHorizontal}>
    <div class="is-small" class:field-label={isHorizontal}>
        <label class="label is-small">{@html label}</label>
    </div>
    <div class="field-body">
        <div class="field">
            <div class="control">
                <ImageUploader
                        uploadFile={uploadTheIcon}
                        {deleteImage}
                        {inProgress}
                        {imageUrl}/>
            </div>
        </div>
    </div>
</div>
